import { alpha } from '@mui/system';
export var ToggleButtonTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState;
            return ({
                '&:only-of-type': {
                    border: 'none',
                    borderRadius: "100%",
                    '&.Mui-selected': {
                        backgroundColor: "transparent",
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                        },
                    },
                },
            });
        },
    },
    variants: [
        {
            props: {
                size: 'small',
            },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    padding: theme.spacing(0.375),
                    minWidth: 32,
                    minHeight: 32
                });
            },
        },
        {
            props: {
                size: 'medium',
            },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    padding: theme.spacing(0.875),
                    minWidth: 40,
                    minHeight: 40
                });
            },
        },
        {
            props: {
                size: 'large',
            },
            style: {
                minWidth: 56,
                minHeight: 56
            },
        },
    ],
}); };
export default ToggleButtonTheme;
//# sourceMappingURL=theme.js.map